import React from 'react'
import './Experience.css'

const Experience = () => {
    return (
        <>
            <div className='experience-container'>
                <br></br><br></br><br></br><br></br><br></br><br></br>
                <h2>Head of Publicity</h2>
                <h3>Zeitgeist '24, IIT Ropar</h3>
                <p>July '24 - Oct '24</p>
                <br></br><br></br><br></br><br></br>
                <h2>Head of Design</h2>
                <h3>Board of Wellness, IIT Ropar</h3>
                <p>July '24 - May '25</p>
                <br></br><br></br><br></br><br></br>
                <h2>Ex- Coordinator</h2>
                <h3>Coding & Astronomy Club, IIT Ropar</h3>
                <p>July '23 - April '24</p>
                <br></br><br></br><br></br><br></br>
                <h2>Indo - Finnish Winter School</h2>
                <h3>IIT Delhi</h3>
                <p>Nov '24</p>
                <br></br><br></br><br></br><br></br>
                <h2>Inter IIT Cult Meet 7.0</h2>
                <h3>IIT Patna</h3>
                <p>Dec '24</p>
            </div>
        </>

    )
}

export default Experience
